import { fsErrorMessages } from '@repo/lib/messages/fsErrorMessages';
import { useQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { FileService } from './fileService';
import { FileKey } from './keys';

export function useGetFilePermissions(id?: string, enabled = true) {
  const getFilePermissionsQuery = useQuery({
    queryKey: [FileKey.FILE_PERMISSIONS, id],
    queryFn: () => FileService.getFilePermissions(id).then((response) => response.data),
    enabled: enabled && !!id,
  });

  const errorMessage = useErrorMessage(getFilePermissionsQuery.error, fsErrorMessages);

  return { ...getFilePermissionsQuery, errorMessage };
}
